/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React, { useState } from 'react';
import {
    object, string, shape, bool,
} from 'prop-types';
import { useLazyQuery, gql } from '@apollo/client';
import Button from '@material-ui/core/Button';
import mbpLogger from 'mbp-logger';
import { withStyles } from '@material-ui/core/styles';
import { GRAPHQL_ENV } from '../../../../../../gql/index';
import PDPDeliveryPopup from '../PDPDeliveryPopup';

const styles = (theme) => ({
    title: {
        textAlign: 'center',
        margin: 0,
        padding: 7,
    },
    popupButton: {
        boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
        fontSize: '12px',
        fontWeight: 'bold',
        width: '100%',
        padding: '10px',
        '&:hover': {
            backgroundColor: 'inherit',
        },
        [theme.breakpoints.up(600)]: {
            marginTop: 15,
        },
    },
    deliveryDetail: {
        display: 'flex',
        '&.orderDetails': {
            flexDirection: 'column',
            alignItems: 'center',
        },
        '&.orderDetailsMargin': {
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '1.2em',
        },
    },
    deliveryDetailsIcon: {
        display: 'block',
        width: 32,
    },
    titleCheckout: {
        textAlign: 'left',
        margin: 0,
        padding: 7,
    },
    titleOrderDetails: {
        color: '#4A90E2',
        fontSize: '11px !important',
        textAlign: 'center',
        textTransform: 'capitalize',
        textDecoration: 'underline',
        marginBottom: '0 !important',
    },
    popupButtonCheckout: {
        fontSize: '12px',
        fontWeight: 'bold',
        width: '100%',
        padding: '10px 0',
        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
    popupButtonOrderDetails: {
        fontSize: '12px',
        fontWeight: 'bold',
        width: '100%',
        backgroundColor: 'transparent !important',
        border: 'none !important',
        minWidth: '50px !important',
        marginRight: '0 !important',
        position: 'absolute',
        top: 'calc(-50% + 10px)',
        right: 0,
        padding: 0,
        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
});
const PDPDeliveryPopupContainer = ({
    brand, productDeliveryType, classes, pageType, isPDPCalendarPopupEnabled, isROSSPassport,
}) => {
    if (!isPDPCalendarPopupEnabled) {
        return null;
    }
    const [openModal, closeModal] = useState(false);
    function toggle() {
        closeModal(!openModal);
    }
    const contentType = 'design_and_delivery_details';
    const DELIVERY_POPUP_QUERY = gql`{
        findContent(brand: "${brand.domain}", environment: "${GRAPHQL_ENV}", contentType: "${contentType}", query:"{\\"title\\" : \\"${productDeliveryType}\\"}")
        { content }
    }
    `;
    const [getDeliveryPopupDetail, { data, loading, error }] = useLazyQuery(DELIVERY_POPUP_QUERY);
    if (loading) {
        return null;
    }
    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: DELIVERY_POPUP_QUERY,
            jsError: error,
            component: 'PDPDeliveryPopupContainer.js',
            message: `Failed to fetch content data for: content type ${contentType} on brand ${brand}`,
            env: GRAPHQL_ENV,
        });
    }
    const popUpData = data?.findContent?.content?.entries || [];

    let buttonStyle = classes.popupButton;
    if (pageType === 'checkout') {
        buttonStyle = classes.popupButtonCheckout;
    } else if (pageType === 'order-details') {
        buttonStyle = classes.popupButtonOrderDetails;
    }

    let deliveryDetailStyle = classes.deliveryDetail;
    if (pageType === 'order-details') {
        //   deliveryDetailStyle = `${classes.deliveryDetail} orderDetails`;
        deliveryDetailStyle = isROSSPassport ? `${classes.deliveryDetail} orderDetailsMargin` : `${classes.deliveryDetail} orderDetails`;
    }

    let titleStyle = classes.title;
    if (pageType === 'checkout') {
        titleStyle = classes.titleCheckout;
    } else if (pageType === 'order-details') {
        titleStyle = classes.titleOrderDetails;
    }

    let buttonText = productDeliveryType === 'FPT' ? 'Designed & Delivered by a Local Shop: What to Expect' : 'Your Carrier-Shipped Gift: What to Expect';
    if (pageType === 'order-details') {
        buttonText = 'Learn More';
    }

    // flowers or berries or fruit bouquets
    return (
        <>
            <Button
                data-testid="pdp-delivery-details"
                className={buttonStyle}
                style={{ whiteSpace: 'nowrap' }}
                onClick={() => {
                    getDeliveryPopupDetail();
                    closeModal(!openModal);
                }}
            >
                {productDeliveryType === 'FPT'
                    ?                       (
                        <div className={deliveryDetailStyle}>
                            <img className={classes.deliveryDetailsIcon} src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltdf053a55cf248f00/5fdb4688b47cdf7fc7d68a4a/group_1607.svg" alt="details_icon"  />
                            <p className={titleStyle}>{buttonText}</p>
                        </div>
                    )
                    : (
                        <div className={deliveryDetailStyle}>
                            <img className={classes.deliveryDetailsIcon} src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt509d57c10562da7a/5fdb4689396e65084a9e5495/group_1625.svg" alt="details_icon"  />
                            <p className={titleStyle}>{buttonText}</p>
                        </div>
                    )}
            </Button>
            <PDPDeliveryPopup popUpData={popUpData} closeModal={toggle} openModal={openModal} />
        </>
    );
};
PDPDeliveryPopupContainer.propTypes = {
    classes: object.isRequired,
    brand: shape({
        domain: string,
    }).isRequired,
    pageType: string,
    productDeliveryType: string.isRequired,
    isPDPCalendarPopupEnabled: bool.isRequired,
    isROSSPassport: string,
};

PDPDeliveryPopupContainer.defaultProps = {
    pageType: '',
    isROSSPassport: '',
};

export default withStyles(styles)(PDPDeliveryPopupContainer);
